module.exports = __webpack_public_path__ + "675271e764d7dca1c5a9d3e128d54d82.svg";